import React, { useState } from "react";
import { useSnackbar } from "notistack";
import Spiner from "../../components/General/Spiner";
import FormModal from "../../components/General/FormModal";
import Simboloveris from "../../assets/Simbolo.png";
import AuthLogic from "../../functions/logic/Auth";

const LoginForm = () => {
  const [username, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [spiner, setSpiner] = useState(false);
  const [isOpenModalform, setIsOpenModalForm] = useState(false);

  const [authType, setAuthType] = useState("I"); // Estado para el tipo de usuario

  const handleSubmit = async (event) => {
    event.preventDefault();
    setSpiner(true);
    setLoading(true);
    const resp = await AuthLogic.loginLogic(event.target);
    enqueueSnackbar(resp.message, {
      variant: resp.variant,
      anchorOrigin: {
        vertical: "top",
        horizontal: "right",
      },
    });
    setSpiner(false);
    setLoading(false);
    setTimeout(function () {
      if (resp.success) {
        window.location = global.TABLERO_LIST;
      }
    }, global.DELAY);
  };

  const handleForgotPassword = async () => {
    setSpiner(true);
    setIsOpenModalForm(true);
    setSpiner(false);
  };

  const handleCloseModal = () => {
    setIsOpenModalForm(false);
  };

  return (
    <div className="login-form-container">
      <Spiner opt={spiner} />
      <FormModal
        isOpen={isOpenModalform}
        handleCloseModal={handleCloseModal}
        opt={"forgot"}
        modalWith={"xs"}
      />
      <img src={Simboloveris} alt="logo" className="responsive-logo" />
      <h2 className="form-title">Iniciar Sesión</h2>
      <p className="form-description">Por favor ingresa usuario y contraseña</p>

      <form onSubmit={handleSubmit} className="login-form">
        <div className="form-group">
          <label htmlFor="user" className="label-left">
            Usuario:
          </label>
          <input
            id="user"
            name="user"
            type="text"
            value={username}
            onChange={(e) => setUserName(e.target.value)}
            placeholder="Ingrese su usuario"
          />
        </div>

        <div className="custom-password">
          <div className="custom-password-container">
            <label htmlFor="password" className="label-left">
              Contraseña:
            </label>
            <span className="custom-forgot-link" onClick={handleForgotPassword}>
              ¿Olvidaste tu Contraseña?
            </span>
          </div>

          <input
            id="password"
            type="password"
            name="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Ingrese su contraseña"
            className="custom-input"
          />
        </div>
        <br />
        <div className="form-group">
          <label htmlFor="authType" className="label-left">
            Tipo de Usuario:
          </label>
          <select
            id="authType"
            name="authType"
            value={authType}
            onChange={(e) => setAuthType(e.target.value)}
            className="custom-select"
          >
            <option value="I">Interno</option>
            <option value="E">Externo</option>
          </select>
        </div>

        <br />

        <button type="submit" className="submit-button">
          {loading ? "Cargando..." : "Iniciar sesión"}
        </button>
      </form>
    </div>
  );
};

export default LoginForm;
